<style scoped>
.atd-theme-group{
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
}

.atd-theme-group div{
    /* border: 1px solid blue; */
    width: 120px;
    text-align: center;
}
</style>
<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="row">
    <!-- {{themeData}} -->
    <!-- Main content -->
    <div class="col-md-2 p-t-15">
            <div>Font-Size</div>
            <el-select clearable filterable v-model="themeObj.font_size" @change="$emit('themeChange',themeObj)">
              <el-option v-for="(fontSize,index) in allFontSizes"
                  :key="index"
                  :label="fontSize"
                  :value="fontSize"
                  >
                  </el-option>
            </el-select>
          </div>
          <div class="col-md-3 p-t-15">
            <div>Font-Style</div>
            <el-select  clearable  filterable v-model="themeObj.font_family"  @change="$emit('themeChange',themeObj)">
              <el-option v-for="(font,id) in googleFontList" :key="id"
                  :label="`${font.text}`"
                  :value="font.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="p-t-15">
            <div class="col-md-2 atd-theme-group">
              <div>Font Color</div>
                <swatch v-model="themeObj.font_color" colors="text-advanced" popover-to="top" style="width: 50px; height: 42px;" show-fallback  @input="$emit('themeChange',themeObj)"></swatch>
            </div>
            <div class="col-md-2 atd-theme-group">
              <div>CTA Color</div>
              <swatch v-model="themeObj.cta_color" colors="text-advanced" popover-to="top" style="width: 50px; height: 42px;" show-fallback  @input="$emit('themeChange',themeObj)"></swatch>
            </div>
            <div class="col-md-2 atd-theme-group">
              <div>Background Color</div>
              <swatch v-model="themeObj.background_color" colors="text-advanced" style="width: 50px; height: 42px;" show-fallback  @input="$emit('themeChange',themeObj)"></swatch>
            </div>
          </div>
    <!-- /.content -->
  </div>
  <!-- </transition> -->
</template>
<script>
import axios from "axios";
import Swatches from 'vue-swatches'
export default {
  props:['themeData'],
  components: {
		'Swatch' : Swatches,
	},
  watch: {
    themeData: function() {
      this.themeObj = Object.assign({},this.themeData);
    }
  },
  data() {
    return {
      fontFamily:'',
      fontSize:'',
      allFontSizes:[],
      googleFontList:[],
      themeObj: {font_size:'',font_color:'',font_family:'',background_color:'',cta_color:''}
    };
  },
  created: function () {
    this.createFontSizeList()
    this.getGoogleFonts()
    if(this.themeData){
      this.themeObj = Object.assign({},this.themeData)
    }
  },
  methods: {
    createFontSizeList(){
      for(var i=8;i<31;i++){
          this.allFontSizes.push(i+'px')
      }
    },
    getGoogleFonts() {
        let ref = this;
        const KEY = 'AIzaSyAOK2XUXTAr139VoPxHZ2jscS9-HlwdiME';
        axios({
            url: 'https://www.googleapis.com/webfonts/v1/webfonts?key=' + KEY,
            method: 'GET'
        }).then((res) => {
            for (var i in res.data.items) {
                ref.googleFontList.push({
                    text: res.data.items[i].family,
                    label: res.data.items[i].family,
                    id: res.data.items[i].family,
                });
            }
        });
    },

  }
};
</script>



// WEBPACK FOOTER //
// Theme.vue?39df23b0